
import { responsecreateProduct } from "../../http/res/response-create-product";
import { Expense } from "../../expense/expense";

export class CreateNewProduct {
    expense: Expense;
    data: responsecreateProduct;
    add_comapin: boolean;
    ordinal:number;
    constructor(expense,data,add_comapin) {
        this.expense = expense;
        this.data = data;
        this.add_comapin = add_comapin;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/info-expense/create-new-product.ts